import React, { Fragment } from 'react'
import numeral from 'numeral'

import {
    formatcoin
} from '../../utils/helpers'

export const RowControlFacturacion = ({ origen, documento, enums, totalDetalles, divisa }) => {
    const detalleTotales = totalDetalles(documento)
    const detallesOrigen = totalDetalles(origen)

    return (
        <Fragment>
            <tr >
                <td>{enums.documentos.tipos[documento.get('tipo')].PREFIJO + documento.get('consecutivo')}</td>

                {
                    (documento.get('tipo') == 6) ? (
                        <Fragment>
                            <td style={{ textAlign: 'right' }}></td>
                            <td style={{ textAlign: 'right' }}></td>
                            <td style={{ textAlign: 'right' }}>{numeral(origen.get('anticipo') / 100).format('0.0%')}</td>
                            <td style={{ textAlign: 'right' }}> {formatcoin((origen.get('anticipo') / 100 * detallesOrigen.sin_iva_sin_adiciones), divisa.simbolo)}</td>
                        </Fragment>
                    ) : (
                            <Fragment>
                                <td style={{ textAlign: 'right' }}>{ formatcoin((detalleTotales.sin_iva), divisa.simbolo) }</td>
                                <td style={{ textAlign: 'right' }}>{ formatcoin((detalleTotales.con_iva), divisa.simbolo) }</td>
                                <td style={{ textAlign: 'right' }}>0%</td>
                                <td style={{ textAlign: 'right' }}>{ formatcoin(0, divisa.simbolo) }</td>
                            </Fragment>
                        )
                }
            </tr>
            {
                documento.get('tipo') === 4 && documento.get('documentos').count() > 0 ?
                    documento.get('documentos').map((sub, idx) =>
                        <RowControlFacturacion origen={documento} documento={sub} key={`tr12[${idx}]`}
                            enums={enums} totalDetalles={totalDetalles} divisa={divisa}/>) : null
            }
        </Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Documentos/RowControlFacturacion.jsx